var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00585938H513V341.994H0V-0.00585938Z",
    fill: "#055E1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.906 204.446C183.906 216.765 193.656 226.75 205.685 226.75H271.02C271.02 237.014 279.146 245.337 289.17 245.337H310.948C320.972 245.337 329.098 237.015 329.098 226.75V204.446H183.906ZM330.909 96.6405V148.684C330.909 156.883 324.396 163.553 316.39 163.553V185.857C336.405 185.857 352.686 169.182 352.686 148.684V96.6405H330.909ZM174.832 148.685C174.832 156.884 168.319 163.554 160.312 163.554V185.858C180.328 185.858 196.609 169.183 196.609 148.685V96.6415H174.831V148.685H174.832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.242 96.6375H320.02V148.681H298.242V96.6375ZM265.574 126.381C265.574 128.43 263.946 130.098 261.944 130.098C259.942 130.098 258.314 128.43 258.314 126.381V96.6405H236.536V126.381C236.536 128.43 234.907 130.098 232.906 130.098C230.904 130.098 229.276 128.43 229.276 126.381V96.6405H207.497V126.381C207.497 140.728 218.895 152.402 232.905 152.402C238.3 152.402 243.305 150.666 247.424 147.716C251.542 150.666 256.548 152.402 261.943 152.402C263.029 152.402 264.097 152.324 265.149 152.187C263.606 158.698 257.88 163.554 251.054 163.554V185.858C271.069 185.858 287.351 169.183 287.351 148.685V96.6405H265.572L265.574 126.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.497 163.55H240.162V185.854H207.497V163.55Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00585938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/SA.f3c5360927d9cf2e6d3d67a11d216175.svg";
export { ForwardRef as ReactComponent };